import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import HomePage from './HomePage/HomePage';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';

const FrontPage = () => {
    const {settings} = useSelector(state => state.settings);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const isNewFeatureTester = localStorage.getItem("NewFeatureTester");
        if (isNewFeatureTester == 'true' && (!settings?.ritualsOk || settings?.ritualsOk !== moment().startOf('date').toISOString())) {
            if(settings?.ritualMorning && settings?.ritualMorningTime){
                const now = new Date();
                const [startHour, startMinute] = settings?.ritualMorningTime.split(':').map(Number);
                const startDateTime = new Date(now.getFullYear(), now.getMonth(), now.getDate(), startHour, startMinute);
                const [endHour, endMinute] = settings?.ritualEveningTime ? settings?.ritualEveningTime.split(':').map(Number) : [23, 59];
                const endDateTime = new Date(now.getFullYear(), now.getMonth(), now.getDate(), endHour, endMinute);
                if(now >= startDateTime && now <= endDateTime){
                    navigate('/morning-rituals');
                    return () => {}
                }
            }
        }

        setLoading(false);
    }, [settings]);

    return (
        loading ? <div></div> : <HomePage />
    )
}

export default FrontPage